export default __webpack_public_path__ + "static/media/indra_nooyi_2.ab7a854b.jpg";